import { Box, ButtonBase } from "@mui/material";
import ShTextSkeleton from "../../../theme/skeleton/ShTextSkeleton";
import Text from "../../../theme/text/Text";
import ShCopyButton from "../../../theme/ShCopy";
import { ORDER_FILTER_KEYS } from "../../DataGrid/Filter";
import ShLabelSkeleton from "../../../theme/skeleton/ShLabelSkeleton";
import SHQuickAction from "../../../theme/Modal/SHQuickAction";
import ShLabel from "../../../theme/label/ShLabel";
import { getOrderStateData } from "../../../../utils/labelColorText";
import OrdersCard from "../../cards/orders/OrdersCard";
import { HighlightedColumn } from "./HighlightedColumn";
import RhOrdersCard from "./cards/RhOrdersCard";
import { getTrackingLink } from "../../../../utils/shipping";
import OpenInNewOutlinedIcon from '@mui/icons-material/OpenInNewOutlined';
import WarehouseLocationCard from "../../cards/stock/WarehouseLocationCard";
import Subheading from "../../../theme/text/Subheading";
import { useState } from "react";
import SHModal from "../../../theme/Modal/SHModal";
import Shbutton from "../../../theme/buttons/Shbutton";
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import ButtonGroup from "../../../theme/buttons/ButtonGroup";

export const rhWarehouseLocationColumns =  (i18n,theme,t,colors,columnStrategy, setRow) => {
    
    return [
        {
            field: "location",
            headerName: t("location"),
            flex:1,
            renderCell : (params) => {
                if(params.row.skeleton) {
                    return <ShLabelSkeleton variant={"yellow"}/>
                }
                return (
                    <ShLabel clickable={true} size={32} fitted variant={"yellow"}>
                        {params.row.location}
                    </ShLabel>
                );
            }
        },
        // {
        //     field: "warehouseLevel",
        //     headerName: t("level"),
        //     flex:1,
        //     renderCell : (params) => {
        //         if(params.row.skeleton) {
        //             return <ShTextSkeleton/>
        //         }
        //         return params.row.warehouseLevel?.description
        //     },
        // },
        {
            field: "warehouseLocationType",
            headerName: t("location_type"),
            flex:1,
            renderCell : (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }
                return params.row.warehouseLocationType?.description
            },
        },
        {
            field: "warehouseZone",
            headerName: t("zone"),
            flex:1,
            renderCell : (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }
                return params.row.warehouseZone?.description
            }
        },
        // {
        //     field: "reachType",
        //     headerName: t("reachtype"),
        //     flex:1,
        //     renderCell : (params) => {
        //         if(params.row.skeleton) {
        //             return <ShTextSkeleton/>
        //         }
        //         return params.row.reachType?.description
        //     },
        // },
        {
            field: "availableStock",
            headerName: t("available_stock"),
            sortable:false,
            flex:3,
            renderCell : (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }
                
                // Group palletspots by relation
                const groupedByRelation = {};
                params.row.palletspots?.forEach(spot => {
                    const relationKey = spot.relationId || 'unknown';
                    const relationName = spot.relationName;

                    if (!groupedByRelation[relationKey]) {
                        groupedByRelation[relationKey] = {
                            relationName,
                            spots: []
                        };
                    }
                    groupedByRelation[relationKey].spots.push(spot);
                });

                return (
                    <SHQuickAction
                        maxWidth={600}
                        component= {
                            <Box
                                sx={{
                                    display:"grid",
                                    gridTemplateColumns:"repeat(2, 1fr)",
                                    gap:4,
                                    maxHeight:500,
                                    overflow:'auto',
                                }}
                            >
                                {Object.entries(groupedByRelation).map(([relationKey, relationData], zoneIdx) => (
                                    <Box
                                        key={"zone-"+relationKey}
                                        sx={{
                                            width:300,
                                        }}
                                    >
                                        <Text noBreak bold sx={{mb:1}}>{relationData.relationName}</Text>
                                        <Box
                                            sx={{
                                                display:"flex",
                                                gap:4,
                                            }}
                                        >
                                            <Text noBreak light sx={{flex:1}}>{t("date")}</Text>
                                            <Text noBreak light sx={{flex:1}}>{t("total_quantity")}</Text>
                                        </Box>
                                        {relationData.spots.map((spot,idx) => (
                                            <Box
                                                key={"prps"+idx}
                                                sx={{
                                                    width:1,
                                                    display:"flex",
                                                    gap:4,
                                                    mt:1,
                                                }}
                                            >
                                                <Text noBreak sx={{flex:1}}>{new Date(spot.date)?.toISOString().split('T')[0]}</Text>
                                                <Text noBreak sx={{flex:1}}>{spot.amountOfProducts}</Text>
                                            </Box>
                                        ))}
                                    </Box>
                                ))}
                            </Box>
                        }
                    >
                        {({anchorEl, onMouseEnter, onMouseLeave, onTouchStart }) => {
                            const relationCount = Object.keys(groupedByRelation).length;
                            const hasMultipleRelations = relationCount > 1;

                            // Determine if hover should be enabled
                            const enableHover = relationCount <= 3;

                            // Limit to 3 relations
                            const visibleRelations = Object.entries(groupedByRelation).slice(0, 3);

                            return (
                                <Box
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        setRow(params.row);
                                    }}
                                    aria-owns={anchorEl ? "simple-popover" : undefined}
                                    onMouseEnter={enableHover && params.row.palletspots?.length > 1 ? onMouseEnter : null}
                                    onMouseLeave={enableHover && params.row.palletspots?.length > 1 ? onMouseLeave : null}
                                    onTouchStart={enableHover && params.row.palletspots?.length > 1 ? onTouchStart : null}
                                    sx={{
                                        width:1,
                                        height:1,
                                        display: hasMultipleRelations ? "grid" : "flex",
                                        gridTemplateColumns: hasMultipleRelations ? "repeat(3, 1fr)" : undefined,
                                        alignItems:'center',
                                        gap: hasMultipleRelations ? 1 : 0,
                                    }}
                                >
                                    {hasMultipleRelations ? (
                                        <>
                                            {visibleRelations.map(([relationKey, relationData], idx) => {
                                                const lastSpot = relationData.spots[relationData.spots.length - 1];
                                                return (
                                                    <Box
                                                        key={relationKey}
                                                        sx={{
                                                            display: "flex",
                                                            justifyContent:'space-between',
                                                        }}
                                                    >
                                                        <Box
                                                            sx={{
                                                                display: "flex",
                                                                flexDirection: "column",
                                                                gap: 0.5,
                                                                alignItems: "flex-start",
                                                            }}
                                                        >

                                                            <Text>{lastSpot.amountOfProducts}</Text>
                                                            <Text light sx={{ fontSize: 11 }}>
                                                                ({relationData.relationName})
                                                            </Text>
                                                        </Box>


                                                        {relationCount > 3 && idx === 2 && (
                                                            <ButtonBase 
                                                                sx={{
                                                                    background:theme.palette.mode === "dark" ? colors.txt["secondary"] : colors.grey[400],
                                                                    color:theme.palette.mode === "dark" ? colors.txt["primary"] : colors.txt["light"],
                                                                    fontSize:14,
                                                                    fontWeight:500,
                                                                    fontFamily:"Roboto, sans-serif",
                                                                    height:32,
                                                                    borderRadius:4,
                                                                    px:2,
                                                                }}
                                                            >
                                                                +{relationCount - 3} {t("more")}
                                                            </ButtonBase>
                                                        )}
                                                    </Box>
                                                );
                                            })}
                                        </>
                                    ) : (
                                        <Box
                                            sx={{
                                                display:"flex",
                                                flexDirection:"column",
                                                gap:0.5,
                                                alignItems:"flex-start",
                                            }}
                                        >
                                            <Text>{params.row.palletspots?.[0].amountOfProducts}</Text>
                                            <Text light sx={{fontSize:11}}>({params.row.palletspots?.[0].relationName})</Text>
                                        </Box>
                                    )}
                                </Box>
                            );
                        }}
                    </SHQuickAction>

                );
                return  params.row.availableStock//cellValues.row.product.relation.name
            },
        },
        {
            field: "phoneView", 
            headerName: "PhoneView",
            cellClassName: "phone-column--cell",
            // hide: true,
            renderCell: (params) => {
                console.log(params.row);
                return (
                    <WarehouseLocationCard 
                    // onClick={() => getLocationDetails(params)} 
                    skeleton={params.row.skeleton ?? false} {...params.row}/>
                    // <Box
                    //     sx={{
                    //         background:`${theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[100]}`,
                    //         paddingX:2,
                    //         paddingY:1.5,
                    //         borderRadius:2
                    //     }}
                    // >

                    // </Box>
                )
            }
        }
    ]
};